import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Person from '@material-ui/icons/Person';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import _ from 'lodash';
import moment from 'moment';

import { showDialog, hideDialog } from '../../../redux/actions/dialogs';
import { addResource, removeResource, addResources, setResourceEmployee } from '../../../redux/actions/jobs';
import ResourceDetailGrid from '../../Resources/ResourceDetailGrid';
import ResourceInput from '../../Resources/ResourceInput/index';

import ReduxDialog from '../../Common/ReduxDialog/index';

import { toArray, toJS, uuid } from '../../../utils/helper';
import { fetchEmployeesRoutine, fetchRolesRoutine, saveJobResourcesRoutine } from '../../../redux/routines';

import styles from './styles';
import {
  ASSIGN_RESOURCES_DIALOG,
  ASSIGN_RESOURCES_TO_TASKS_DIALOG,
  CONFIRM_DIALOG
} from '../../../redux/constants/dialogs';
import Tooltip from '@material-ui/core/Tooltip';
import { getDialogContextValue } from '../../../redux/selectors';

const isForDate = (resource, date) => {
  return resource.from && moment(resource.from).startOf('day').isSame(date);
}


class AssignResourcesDialog extends Component {
  state = {
    resources: [],
    dates: [],
    dateIdx: 0,
  };

  componentWillMount() {
    this.props.fetchEmployees();
    this.props.fetchRoles();

    this.setState({
      resources: this.props.job.resources,
    });
  }

  // componentWillReceiveProps(newProps) {
  //   console.log('componentWillReceiveProps', newProps);
  //   if (newProps.job && newProps.job.resources) {
  //     const dates = _.uniq(_.values(newProps.job.resources).reduce((res, val) => {
  //       res.push(moment(val.from).startOf('day'));
  //       return res;
  //     }, []));
  //
  //     const resources = filterResources(newProps.job.resources, moment(newProps.currentDate).startOf('d'))
  //       .sort((a, b) => {
  //         return sortStrings(a.id, b.id);
  //       });
  //
  //     this.setState({
  //       dates,
  //       resources,
  //     });
  //   }
  // }

  handleUpdateInput = (searchText, a, b, c) => {
    this.setState({
      searchText,
    });
  };

  // handleSelectEmployee = (employee) => {
  //   console.log('handleSelectEmployee', employee);
  //   this.pr
  // };

  handleSelectRole = (role) => {
    this.setState({
      role,
    });
  };

  // handleAddEmployee = () => {
  //   const { employee, role, resources = [] } = this.state;
  //
  //   if (resources.find((resource) => resource.employee.id === employee.id)) {
  //     return alert('Employee has already been added');
  //   }
  //
  //   resources.push({
  //     employee,
  //     role,
  //   });
  //
  //   this.setState({
  //     resources,
  //     employeeSearchText: '',
  //     roleSearchText: '',
  //   });
  // };

  handleAddResource = (spec) => {
    console.log('handleAddResource', spec);
    const resources = _.range(spec.quantity).map(() => _.assign(_.omit(spec, ['quantity']), { id: uuid() }));
    console.log('addRes', resources);
    // this.props.addResources(this.props.job, resources);
    this.setState({
      resources: _.concat(this.state.resources, resources),
    });
  };

  handleRemoveResource = (resource) => {
    console.log('handleRemoveResource', resource);
    this.props.removeResource(this.props.job, resource);
  };

  handleResetResource = (state) => {
    console.log('handleResetResource', state);
    return state;
  };

  handleAssignResourcesToTasks = () => {
    this.props.hideDialog(ASSIGN_RESOURCES_DIALOG);
    this.props.hideDialog(CONFIRM_DIALOG);
    this.props.showDialog(ASSIGN_RESOURCES_TO_TASKS_DIALOG);
  };

  handleSave = () => {
    const { job } = this.props;
    job.resources = this.state.resources;
    this.props.saveJobResources(job);

    // TODO restore
    // if (job.tasks && job.tasks.count > 0) {
    //   this.props.showDialog(ASSIGN_RESOURCES_DIALOG');
    //   this.props.showDialog(CONFIRM_DIALOG', {
    //     title: 'Assign resources to tasks',
    //     message: 'Would you like to assign resources to tasks?',
    //     buttons: [<Button         variant="text"
    //       label="No"
    //       onClick={() => {
    //         this.props.hideDialog(CONFIRM_DIALOG);
    //         this.props.hideDialog(ASSIGN_RESOURCES_DIALOG);
    //       }}
    //     />,
    //       <Button
    // variant="text"
    //         label="Yes"
    //         primary
    //         keyboardFocused
    //         onClick={this.handleAssignResourcesToTasks}
    //       />],
    //   });
    // } else {
    this.props.hideDialog(ASSIGN_RESOURCES_DIALOG);
    // }
  };

  // handleAssignEmployeesToStages() {
  //   const { job } = this.props;
  //   this.props.showDialog(ASSIGN_EMPLOYEES_TO_STAGES_DIALOG', {
  //     stages: job.stages,
  //   });
  // }

  renderNoData() {
    return (<TableRow key="nodata">
      <TableCell colSpan={3} style={styles.noDataRow}>
        <Person style={styles.noData}/>
        <div>No resources added yet...</div>
      </TableCell>
    </TableRow>);
  }

  renderResource(resource) {
    const { employees } = this.props;
    let employee = null;
    if (resource.employee) {
      employee = employees.find(((employee) => employee.id === resource.employee.id));
    }
    // const employeeName = resource.employee ? `${resource.employee.name}` : '';
    return (<TableRow key={resource.id}>
      <TableCell style={styles.timeCol}>{moment(resource.from).format('LT')}</TableCell>
      <TableCell style={styles.timeCol}>{moment(resource.to).format('LT')}</TableCell>
      <TableCell style={styles.roleCol}>{resource.role.name}</TableCell>
      <TableCell>
        <Select
          name="employee.id"
          style={styles.input}
          hintText="Employee"
          fullWidth
          value={employee ? employee.id : null}
          onChange={(evt, idx, employeeId) => this.props.setResourceEmployee(this.props.job, resource, employees.find((e) => e.id === employeeId))}
        >
          {(this.props.employees || []).map((e) => <MenuItem key={e.id} value={e.id}>{e.name}</MenuItem>)}
        </Select>
      </TableCell>
      <TableCell style={styles.actionCol}>
        <Tooltip placement="bottom" title="Clear">
          <IconButton
            onClick={() => this.props.setResourceEmployee(this.props.job, resource, null)}
          >
            <i className="material-icons">clear</i>
          </IconButton>
        </Tooltip>
        <Tooltip placement="bottom" title="Remove">
          <IconButton
            onClick={() => this.handleRemoveResource(resource)}
          >
            <i className="material-icons">delete</i>
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>);
  }

  // renderResources(resources, currentDate) {
  //   return (<div style={styles.resources}>
  //     <ResourceInput
  //       fixedDate={currentDate}
  //       onAdd={this.handleAddResource}
  //       onReset={this.handleResetResource}
  //     />
  //
  //     {/*<DatePicker*/}
  //       {/*ref={(dp) => this.dp = dp}*/}
  //       {/*autoOk*/}
  //       {/*style={styles.datePicker}*/}
  //       {/*onChange={(_, date) => this.setState({ currentDate: moment(date) })}*/}
  //     {/*/>*/}
  //     <div>
  //       <Table selectable={false}>
  //         <TableHead displaySelectAll={false} adjustForCheckbox={false}>
  //           <TableRow>
  //             <TableCell style={styles.timeCol}>Start</TableCell>
  //             <TableCell style={styles.timeCol}>End</TableCell>
  //             <TableCell style={styles.roleCol}>Role</TableCell>
  //             <TableCell>Employee</TableCell>
  //             <TableCell style={styles.actionCol}></TableCell>
  //           </TableRow>
  //         </TableHead>
  //         <TableBody displayRowCheckbox={false}>
  //           {resources.length > 0 ? resources.map((resource) => this.renderResource(resource)) : this.renderNoData()}
  //         </TableBody>
  //       </Table>
  //     </div>
  //   </div>);
  // }

  render() {
    const { handleSubmit, job, currentDate, employees, roles, showError } = this.props;

    // const dates = _.uniq(_.values(newProps.job.resources).reduce((res, val) => {
    //   res.push(moment(val.from).startOf('day'));
    //   return res;
    // }, []));

    // const resources = filterResources(job.resources, moment(currentDate).startOf('d'))
    //   .sort((a, b) => {
    //     return sortStrings(a.id, b.id);
    //   });

    console.log('roles', roles);

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => this.props.hideDialog(ASSIGN_RESOURCES_DIALOG)}
      >Cancel</Button>,
      <Button
        key="save"
        variant="text"
        color="primary"
        autoFocus
        onClick={() => this.handleSave()}
      >Save</Button>,
    ];

    return (
      <ReduxDialog
        name={ASSIGN_RESOURCES_DIALOG}
        title="Assign Resources"
        actions={actions}
        modal={false}
        autoScrollBodyContent
        bodyStyle={styles.body}
        maxWidth="md"
        fullWidth
      >
        <div style={styles.body}>
          <Paper style={styles.paper}>
            <Grid container spacing={8}>
              <Grid item xs={4}>
                <label style={styles.label}>Reference</label>
                <div>{job.reference}</div>
              </Grid>
              <Grid item xs={4}>
                <label style={styles.label}>Customer</label>
                <div>{job.customer ? job.customer.name : ''}</div>
              </Grid>
              <Grid item xs={4}>
                <label style={styles.label}>Description</label>
                <div>{job.description}</div>
              </Grid>
            </Grid>
            <Grid container spacing={8}>
              <Grid item xs={4}>
                <label style={styles.label}>Start Date</label>
                <div>{moment(job.start).format('ll')}</div>
              </Grid>
              <Grid item xs={4}>
                <label style={styles.label}>End Date</label>
                <div>{moment(job.end).format('ll')}</div>
              </Grid>
              <Grid item xs={4}>
                <label style={styles.label}>Assignment Date</label>
                <div>{moment(currentDate).format('ll')}</div>
              </Grid>

            </Grid>

          </Paper>

          <form onSubmit={handleSubmit}>

            {/*{this.renderResources(resources, currentDate)}*/}

            {/*<ResourceEditor*/}
            {/*value={resources}*/}
            {/*employees={employees}*/}
            {/*onChange={(a, b, c) => console.log(a, b, c)}*/}
            {/*showError={showError}*/}
            {/*/>*/}

            <ResourceInput
              fixedDate={currentDate}
              onAdd={this.handleAddResource}
              onReset={this.handleResetResource}
              roles={roles}
              showError={showError}
            />

            <ResourceDetailGrid
              value={this.state.resources.filter((resource) => isForDate(resource, currentDate))}
              employees={employees}
              onChange={(resources) => this.setState({ resources })}
            />
          </form>
        </div>
      </ReduxDialog>
    );
  }
}

AssignResourcesDialog.propTypes = {
  job: PropTypes.object,
  employees: PropTypes.array,
  roles: PropTypes.array,

  fetchEmployees: PropTypes.func.isRequired,
  fetchRoles: PropTypes.func.isRequired,

  currentDate: PropTypes.object,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,

  addResources: PropTypes.func.isRequired,
  addResource: PropTypes.func.isRequired,
  removeResource: PropTypes.func.isRequired,
  setResourceEmployee: PropTypes.func.isRequired,

  saveJobResources: PropTypes.func.isRequired,
};

const form = reduxForm({
  form: ASSIGN_RESOURCES_DIALOG,  // a unique identifier for this form
})(AssignResourcesDialog);

function mapStateToProps(state) {
  const currentDate = getDialogContextValue(state)(ASSIGN_RESOURCES_DIALOG, 'currentDate');

  return {
    job: getDialogContextValue(state)(ASSIGN_RESOURCES_DIALOG, 'job').toJS(),
    employees: toJS(state.getIn(['employees', 'employees', 'data'])), //.sort((a, b) => sortStrings(a ? a.name : '', b ? b.name : '')),
    roles: toJS(state.getIn(['roles', 'roles', 'data'])),
    currentDate,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchEmployees: fetchEmployeesRoutine.trigger,
    fetchRoles: fetchRolesRoutine.trigger,
    showDialog,
    hideDialog,
    addResources,
    addResource,
    setResourceEmployee,
    removeResource,
    saveJobResources: saveJobResourcesRoutine.trigger,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Jobs/AssignResourcesDialog/index.js